import I from "../metadata/useInjectMetadata.js";
import { ERROR_CODE as q } from "../../../temp-lib/constants/error.js";
import { useConfigContext as b } from "../../../temp-lib/contexts/config/ConfigContext.js";
import { CustomError as L } from "../../../temp-lib/errors/customError.js";
import { getAccessToken as O } from "../../../temp-lib/util/authenication/index.js";
import { useQueries as S } from "@tanstack/react-query";
import T from "query-string";
import * as t from "ramda";
import { useMemo as $, useCallback as l } from "react";
const v = (p) => {
  const { auth: i = !0, fetchNow: d = !0, path: c, queries: h, deserialize: a } = p, { config: j } = b(), { restful: o } = j, { domain: r } = o || {}, { injectMetadata: u, injectMetadataLegacyMode: f } = I(), s = $(
    () => t.isNotNil(r) ? `${r}${c}` : "",
    [r, c]
  ), N = l(
    async (e) => {
      if (t.isNil(o))
        throw new L(
          'config "restful" is not defined',
          q.GENERAL.MISSING_CONFIG
        );
      const m = O(), E = i && t.isNotNil(m), k = T.stringifyUrl({ url: s, query: e }), w = await fetch(k, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...E ? { Authorization: `Bearer ${m}` } : {}
        }
      }), { buildId: M } = o, R = await w.json(), A = f(R), G = await u(A, M);
      return a(G);
    },
    [i, a, u, f, o, s]
  ), n = S({
    queries: t.map((e) => ({
      enabled: d,
      queryKey: [s, e],
      queryFn: () => N(e)
    }), h)
  }), g = l(() => {
    t.forEach((e) => {
      e.refetch();
    }, n);
  }, []), y = t.pluck("data", n), C = t.pluck("error", n);
  return { data: y, errors: C, refetch: g };
};
export {
  v as default
};
//# sourceMappingURL=useGetRestfulQueries.js.map
